<template>
  <div class="text-center">
    <p>
      <strong>Your request for data deletion is successfully registered.</strong>
    </p>
    <p>
      Game account will be deleted within 15 days from your request.
    </p>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ResultData',
};
</script>
